export default "__VITE_ASSET__Bpa0q5HR__"